export default {
	sec_01: {
		title: {
			one: 'JP WORLD Pay ',
			two: '카드',
		},
		desc: {
			one: '직불 및 선불 카드로 JP WORLD Pay잔액에 엑세스 하거나',
			two: '신용 제품 중 하나로 일상적인 구매에 쉽게 자금을',
			three: '조달할 수 있습니다.',
		},
	},
	sec_08: {
		title: 'JP WORLD Pay 크레딧',
		one: {
			desc: {
				one: '지금 구매하고 시간이 지남에 따라 지불.',
				two: 'JP WORLD PAY가 허용되는 모든 곳에서',
				three: '10,000엔 이상 구매 시 특별 금융을 받으세요.',
			},
			btn: 'JP WORLD PAY 크레딧에 대해 알아보기',
		},
		two: {
			desc: {
				one: '10,000엔을 구매 할 때 마다 6개월 이내에',
				two: '전액을 지불하는 경우 이자가 없습니다.',
				three: '6개월 이내에 잔액을 완납하지 않으면 구매일로부터',
				four: '이자가 귀하의 계정으로 청구됩니다.',
				five: '최소 월별 지불이 필요합니다. 신용 승인 대상.',
			},
			btn: '약관보기',
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'NEW',
				two: 'JP WORLD Pay',
				three: '캐시백 (JPYS 코인)',
			},
			desc: {
				one: 'JP WORLD Pay구매 시 무제한 3% 캐시백',
				two: '기타 모든 구매 시 무제한 2%를 받으세요.',
				three: '언제 사용 할 수 있는지 가장 먼저 알아보세요.',
				four: '기존 2% 캐쉬백 소지자는 목록에 가입 할 필요가 없습니다.',
				five: '업그레이드를 자동으로 받게 됩니다.',
			},
			btn: 'Learn about JP WORLD Pay Credits',
		},
		two: {
			title: {
				one: 'JP WORLD Pay',
				two: '현금카드',
			},
			desc: {
				one: 'JP WORLD Pay잔액에 연결 된 직불카드로',
				two: '자금에 액세스하여',
				three: '자금을 쉽게 관리 할 수 있습니다.',
			},
			btn: 'JP WORLD Pay현금카드 정보',
		},
	},
	common: {
		coming_soon: '준비중 입니다.',
	},
};
